import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Bell, ChevronRight } from "lucide-react";
import { fmtDateTime } from "@/lib/adega";

export default function NotificationsSheet({ onClose, onOpenRef }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => {
      setItems(data);
      if (data.some((n) => !n.read)) api.post("/notifications/read-all").catch(() => {});
    }).catch(() => setItems([]));
  }, []);

  return (
    <Sheet open onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent side="bottom" className="max-h-[80dvh] overflow-y-auto rounded-t-3xl bg-card border-t border-white/10 pb-24" data-testid="notifications-sheet">
        <SheetHeader className="text-left mb-3">
          <SheetTitle className="text-2xl heading font-extrabold flex items-center gap-2"><Bell className="w-5 h-5 text-primary" /> Notificações</SheetTitle>
        </SheetHeader>
        {items === null && <p className="text-sm text-muted-foreground">Carregando...</p>}
        {items?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="notifications-empty">Sem novidades por aqui.</p>}
        <ul className="space-y-2">
          {items?.map((n) => (
            <li key={n.notification_id}>
              <button onClick={() => onOpenRef(n.event_id)} className={`w-full text-left flex items-center gap-3 rounded-xl px-3 py-3 border press ${n.read ? "border-white/5 bg-muted/40" : "border-primary/40 bg-primary/10"}`} data-testid={`notification-${n.notification_id}`}>
                {!n.read && <span className="h-2 w-2 rounded-full bg-primary shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm">{n.message}</div>
                  <div className="text-[10px] text-muted-foreground mt-0.5">{fmtDateTime(n.created_at)}</div>
                </div>
                {n.event_id && <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />}
              </button>
            </li>
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
